import React from 'react';
import SarasChip from './SarasChip';
import SarasChipContainer from './SarasChipContainer';

const SarasChips = ({chipData, className, onClick, onDelete}) => {

  const handleClick = (currentTarget, key) => {
    if(onClick) onClick(currentTarget, key);
  };

  const handleDelete = (key) => {
    if(onDelete) onDelete(key);
  };

  return (
    <SarasChipContainer>
      {chipData.map((data) => {
        return (
          <li key={data.key} >
            <SarasChip
              className={className}
              size="small"
              data={data}
              onClick={onClick ? handleClick : undefined}
              onDelete={handleDelete}
            />
          </li>
        );
      })}
    </SarasChipContainer>
  );
}

export default SarasChips;
